<template>
  <div>
    <v-server-table ref="table" :columns="columns" :options="options" :url="url" style="overflow: hidden;">
      <div slot="date_reception" slot-scope="props">
        {{ formatDate(props.row.created_at) }}
      </div>
      <div slot="utilisateur" slot-scope="props">
        <span v-if="!getIsEmptyHelper(props.row.original_user_id)">
            {{ getUserById(props.row.gestionnaire_original) }} en tant que {{ getUserById(props.row.gestionnaire) }}</span>
        <span v-else>{{ getUserById(props.row.gestionnaire) }}</span>
      </div>
      <div slot="action" slot-scope="props">
        <span v-html="getLibelleAction(props.row)"></span>
        <!-- <component :is="dynamicComponent" :suivi="props.row" /> -->
      </div>
    </v-server-table>
  </div>
</template>

<script>
  import {getMainTreatmentBasedOnType} from "@/utils/communHelper";
  import {isEmpty} from "@/utils/fileHelper";

  export default {
    name: "Journal",
    data() {
      let self = this;
      return {
        journal: [],
        options: {
          headings: {
            'date_reception': 'Date de réception',
            'utilisateur': 'Utilisateur',
            'action': 'Action',
          },
          filterable: false,
          perPage: 10,
          perPageValues: [1, 10, 25],
          sortable: ['date_reception'],
          requestFunction: function (data) {
            // TODO : Regarder si possible Passer en client-table avec data provenant de dossier.suivis (modifier le with avec sous requete lors de récupération infos dossiers)
            // et passage du dossier en props, afin d'éviter une requete supplémentaire à chaque modification du dossier
            self.url = '/espaceGestion/dossier/getDossierJournalById/' + self.dossier.id;

            return axios.get(self.url, {
              params: data
            })
              .then(function(response){
                // console.log(response.data.data)
                self.$event.emit('stopLoadingJournal');
                return response;
              })
              .catch(function (e) {
                console.log(e);
              }.bind(this));
          },
        },
        columns: ['date_reception', 'utilisateur', 'action'],
        url: '',
      }
    },
    props: ['dossier'],
    mounted() {
      this.$event.on('refreshDossier', () => {
        if (!isEmpty(this.$refs.table)) {
          this.$refs.table.refresh();
        }
      });
    },
    methods: {
      getIsEmptyHelper(value) {
        return isEmpty(value)
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      getUserById(gestionnaire) {
        return gestionnaire ? `${gestionnaire.prenom} ${gestionnaire.nom}` : 'système';
      },
      getLibelleAction(suivi) {
        let libelle = '';
        let routeData = {};
        
        switch (true) {
          case /Changement de statut/.test(suivi.action) :
            let libelleStatus = suivi.status ? (suivi.status.parent ? suivi.status.parent.libelle_bo + ' - ' + suivi.status.libelle_bo : suivi.status.libelle_bo) : '';
            libelle = suivi.action + ' : &nbsp;<span class="text-success">' + libelleStatus + '</span>' + ' (' + suivi.traitement.libelle + ')';
            break;
          case /Réaffectation/.test(suivi.action) :
          case /Affectation/.test(suivi.action) :
            libelle = suivi.action;
            if (suivi.gestionnaire_affecte) {
              libelle = suivi.action + ' à : &nbsp;<span class="text-warning"> ' + suivi.gestionnaire_affecte.prenom + ' ' + suivi.gestionnaire_affecte.nom + '</span>' + ' (' + suivi.traitement.libelle + ')';
            }

            break;
          case /Réouverture du dossier/.test(suivi.action) :
            let commentaireReouverture = !isEmpty(suivi.commentaire) ? ' : ' + suivi.commentaire : '';
            libelle = suivi.action + commentaireReouverture;

            break;
          case /Duplication du dossier/.test(suivi.action) :
          case /Duplicata du dossier/.test(suivi.action) :
            if (suivi.commentaire.indexOf('°') > -1) {
              routeData = this.$router.resolve({name: 'fiche dossier', params: { id: suivi.commentaire.substring(suivi.commentaire.indexOf('°')+1) }, query: this.$route.query});
              libelle = suivi.commentaire.substring(0,suivi.commentaire.indexOf('°')+1) + '<a href="'+routeData.href+'" target="_BLANK">' + suivi.commentaire.substring(suivi.commentaire.indexOf('°')+1) + '</a>';
            } else {
              routeData = this.$router.resolve({name: 'fiche dossier', params: { id: suivi.commentaire }, query: this.$route.query});
              libelle = suivi.action + '<a href="'+routeData.href+'" target="_BLANK">' + suivi.commentaire + '</a>';
            }

            break;
          case /Fusion avec les dossiers/.test(suivi.action) :
          case /Fusion avec dossier maître/.test(suivi.action) :
            let routeFusion = [];
            let dossiers = suivi.commentaire.split(',');

            for (let dossierId of dossiers) {
              let routeQuery = {traitementId: this.$route.query.traitementId};
              routeFusion[dossierId] = this.$router.resolve({name: 'fiche dossier', params: { id: dossierId }, query: routeQuery});
            }

            libelle = suivi.action === 'Fusion avec les dossiers' ? (dossiers.length === 1 ? 'Fusion avec le dossier n°' : suivi.action) : suivi.action + ' n°';
            for (let dossierId of dossiers) {
              libelle = libelle + ' <a href="'+routeFusion[dossierId].href+'" target="_BLANK">' + dossierId + '</a> ';
            }
            break;
          case /Ajout incident/.test(suivi.action) :
          case /Ajout action/.test(suivi.action) :
            libelle = suivi.action + ' : <span class="text-warning">' + suivi.commentaire + '</span>';
            break;
          case /Ajouter une pièce jointe/.test(suivi.action) :
          case /Supprimer une pièce jointe/.test(suivi.action) :
            libelle = suivi.action + ' : <span class="text-warning">' + suivi.commentaire + '</span>';
            break;
          case /Suppression incident/.test(suivi.action) :
            libelle = suivi.action + ' : <span class="text-warning">' + suivi.commentaire + '</span>';
            break;
          case /Création du dossier depuis le mail n°/.test(suivi.action) :
            routeData = this.$router.resolve({name: 'Réception des mails', params: { id: suivi.source_id }});
            libelle = suivi.action + '<a href="'+routeData.href+'" target="_BLANK">' + suivi.source_id + '</a>';
            break;
          case /Fusion automatique avec le dossier retour de DPC/.test(suivi.action) :
            let dossierCibleMainTreatment = getMainTreatmentBasedOnType(suivi.dossier_cible, this.$parent.$parent.$parent.allTraitements);
            // Si on ne trouve pas de traitement principal c'est qu'il s'agit d'un ancien retour de DPC qui n'a pas de données enregistrées
            // Le traitement dans lequel il faut l'ouvrir est donc le PFE
            let routeQuery = null;
            if (isEmpty(dossierCibleMainTreatment)) {
              let traitementPfe = this.$parent.$parent.$parent.allTraitements.find( element => element.libelle_technique === 'qualification_courrier');
              routeQuery = {traitementId: traitementPfe.id};
            } else {
              routeQuery = dossierCibleMainTreatment ? {traitementId: dossierCibleMainTreatment.id} : {traitementId: traitementPfe.id};
            }

            routeData = this.$router.resolve({name: 'fiche dossier', params: { id: suivi.commentaire }, query: routeQuery});
            libelle = 'Fusion automatique avec le dossier retour de DPC n° <a href="'+routeData.href+'" target="_BLANK">' + suivi.commentaire + '</a>';
            break;
          case /Création d'un commentaire/.test(suivi.action) :
          case /Suppression d'un commentaire/.test(suivi.action) :
            let commentaire = !/a:7:{s:5:"texte"/.test(suivi.commentaire) ? JSON.parse(suivi.commentaire) : {texte: ''};
            // console.log(suivi.action, commentaire)
            libelle = commentaire.texte !== '' ? suivi.action + ' : ' + commentaire.texte : suivi.action;
            break;
          case /Changement de type de dossier/.test(suivi.action) :
            let oldType = this.$parent.$parent.$parent.allTypes.reduce((res,type) => type.id === parseInt(suivi.source_id,10) ? type : res,null);
            let newType = this.$parent.$parent.$parent.allTypes.reduce((res,type) => type.id === parseInt(suivi.commentaire,10) ? type : res,null);
            // console.log(oldType,newType)
            if (newType && oldType) {
              libelle = suivi.action + ' : De "' + oldType.libelle + '" à "' + newType.libelle + '"';
            } else if(oldType) {
              libelle = suivi.action + ' : Ancien type = "' + oldType.libelle + '"';
            } else {
              libelle = suivi.action;
            }
            break;
          case /Changement infos/.test(suivi.action) :
          case /Changement infos prestation/.test(suivi.action) :
          case /Changement infos assuré/.test(suivi.action) :
          case /Changement de Produit/.test(suivi.action) :
            libelle = suivi.action + ' : <span>' + suivi.commentaire + '</span>';
            break;
          //HMESS-290
          case /Création du dossier/.test(suivi.action) :
            routeData = this.$router.resolve({name: 'Modification fiche', params: { id: suivi.source_id }});
            libelle = suivi.action + ' <a href="'+routeData.href+'" target="_BLANK">'+suivi.commentaire+'</a>';
            break;
          default:
            libelle = suivi.action;
        }

        return libelle;
      },
    }
  }
</script>
